<template>
  <div class="custom-loading-container">
    <div class="loading-box">
      <div class="icon-box">
        <img v-if="isLogoVisible" src="@/assets/icon/loading.gif" />
        <img v-if="!isLogoVisible" src="@/assets/icon/no-logo-loading.gif" />
      </div>
      <div class="common-global-progress-box">
        <el-progress
          :show-text="false"
          :percentage="percentage"
          :stroke-width="8"
        />
        <div class="custom-text">{{ `${percentage}%` }}</div>
      </div>
      <div class="config-box" v-if="isLogoVisible">{{ currentTip }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLogoVisible: window.isLogoVisible,

      currentTip: "正在为您加载数据，请稍等片刻",
      tips: [
        "推荐使用谷歌、Edge、火狐浏览器登录黑洞引擎",
        "你知道吗，模型的加载速度与它的大小没有直接关系，而与它的三角面片数相关。三角面片数越少，加载速度越快",
        "小tips:按住ctrl键的同时：鼠标点击，代表多选；鼠标拖动，代表框选",
        "小tips:想要批量隐藏构件，可以选中目录树某一层级再点击【隐藏构件】",
        "小tips:引擎工具栏的【地形透明度】仅对GIS数据生效",
        "小tips:WASD可以进行漫游操作，Q和E控制上升和下降",
        "小tips:场景范围过大怎么办，点击目录树可以快速定位",
        "小tips:鼠标左键代表平移，右键代表旋转，按住中键可绕指定点旋转",
      ],
    };
  },
  props: {
    percentage: Number,
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  mounted() {
    this.getTips();
  },
  methods: {
    getTips() {
      this.timer = setInterval(() => {
        let index = Math.floor(Math.random() * 8);
        this.currentTip = this.tips[index];
      }, 3000);
    },
  },
};
</script>

<style lang="less" scoped>
.custom-loading-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .loading-box {
    width: 450px;
    height: 180px;
    margin: auto;
    .icon-box {
      width: 150px;
      margin: auto;

      img {
        width: 100%;
      }
    }

    .common-global-progress-box {
      display: flex;
      width: 180px;
      margin-left: 150px;
      margin-bottom: 10px;
      line-height: 12px;

      /deep/ .el-progress {
        width: 80%;
        .el-progress-bar {
          line-height: 12px;
          border: 1px solid var(--base-border-light-color1);
          padding: 1px;
          border-radius: 10px;

          .el-progress-bar__outer {
            background-color: transparent !important;

            .el-progress-bar__inner {
              line-height: 12px;
              background: var(--base-bg-light-color3);
            }
          }
        }
      }

      .custom-text {
        color: var(--base-border-light-color1);
        margin-left: 10px;
      }
    }
  }

  .config-box {
    max-width: 465px;
    color: var(--eng-loading-text-color);
    font-size: 14px;
    text-align: center;

    .config-title-box {
      font-size: 13px;
      font-weight: bold;
    }

    .config-item-box {
      display: flex;
      margin-top: 5px;

      div {
        margin-right: 20px;
        width: 150px;
      }
    }
  }
}
</style>